import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isAdjustWorkloadRequestPending(
      resourceId,
      projectId,
      from,
      to,
      granularity,
    ) {
      const req = getState().find((req) =>
        matchRequest(req, resourceId, projectId, from, to, granularity),
      );

      return req ? req.request.isPending : false;
    },
    isAdjustWorkloadRequestSuccess(
      resourceId,
      projectId,
      from,
      to,
      granularity,
    ) {
      const req = getState().find((req) =>
        matchRequest(req, resourceId, projectId, from, to, granularity),
      );

      return req ? req.request.isSuccessful : false;
    },
    isAdjustWorkloadRequestFailure(
      resourceId,
      projectId,
      from,
      to,
      granularity,
    ) {
      const req = getState().find((req) =>
        matchRequest(req, resourceId, projectId, from, to, granularity),
      );

      return req ? req.request.isFailure : false;
    },
  };
}

export { createSelector };
